module.exports = __webpack_public_path__ + "media/images/fb_index_image2-c109c5ff0b81191455d85f58e6b45579.png";